export interface FastlyImageParams {
  width?: number;
  height?: number;
  quality?: number;
  format?: 'auto';
  fit?: 'cover' | 'crop' | 'bounds';
  crop?: { aspect?: `${number}:${number}`; smart?: boolean };
}

const greatestCommonDivisor = (a: number, b: number): number => (b === 0 ? a : greatestCommonDivisor(b, a % b));

const deriveAspect = (width: number, height: number): string => {
  const divisor = greatestCommonDivisor(width, height);
  return `${width / divisor}:${height / divisor}`;
};

export function serialiseFastlyParams(params: FastlyImageParams): string {
  const parts: string[] = [];

  if (params.width !== undefined) {
    parts.push(`width=${params.width}`);
  }
  if (params.height !== undefined) {
    parts.push(`height=${params.height}`);
  }
  if (params.quality !== undefined) {
    parts.push(`quality=${params.quality}`);
  }
  if (params.format !== undefined) {
    parts.push(`format=${params.format}`);
  }
  if (params.fit !== undefined) {
    parts.push(`fit=${params.fit}`);
  }
  if (params.crop?.smart) {
    const aspect = params.crop.aspect ?? deriveAspect(params.width ?? 1, params.height ?? 1);
    parts.push(`crop=${aspect},smart`);
  }

  return parts.join('&');
}
